// import * as React from "react";
// import AppBar from "@mui/material/AppBar";
// import Box from "@mui/material/Box";
// import Toolbar from "@mui/material/Toolbar";
// import Typography from "@mui/material/Typography";
// import Button from "@mui/material/Button";
// import IconButton from "@mui/material/IconButton";
// import MenuIcon from "@mui/icons-material/Menu";
// import Sidebar from "./Sidebar";
// import { Select, MenuItem, FormControl, InputLabel, Grid } from "@mui/material";
// import { ApiUrl } from "../ApiUrl";

// function Navbar({ onLogout }) {
//   const [state, setState] = React.useState({
//     top: false,
//     left: false,
//     bottom: false,
//     right: false,
//   });
//   const [academicSession, setAcademicSession] = React.useState("");
//   const [academicYears, setAcademicYears] = React.useState([]);

//  React.useEffect(() => {
//    const fetchAcademicYears = async () => {
//      try {
//        const response = await fetch(
//          `${ApiUrl.apiurl}AcademicYear/GetAllAcademicYear/`
//        );
//        const data = await response.json();
//        if (data.message === "Success") {
//          // Map academic years from API response
//          setAcademicYears(
//            data.data.map((year) => ({
//              id: year.id,
//              code: year.sesion_code,
//              orgId: year.org_id || null,
//              branchId: year.branch_id || null,
//              dateFrom: new Date(year.date_from),
//              dateTo: new Date(year.date_to),
//            }))
//          );
//          // Get the current date
//          const currentDate = new Date();
//          // Find the current academic year based on date range
//          const currentYearData = data.data.find((year) => {
//            const dateFrom = new Date(year.date_from);
//            const dateTo = new Date(year.date_to);
//            return currentDate >= dateFrom && currentDate <= dateTo;
//          });
//          // Set the current academic session if found
//          if (currentYearData) {
//            setAcademicSession(currentYearData.sesion_code);
//            localStorage.setItem("academicSessionId", currentYearData.id);
//            localStorage.setItem("orgId", currentYearData.org_id || "");
//            localStorage.setItem("branchId", currentYearData.branch_id || "");
//            // Set the next academic session in localStorage if it exists
//            const nextYear = data.data.find(
//              (year) =>
//                new Date(year.date_from) > new Date(currentYearData.date_to)
//            );
//            if (nextYear) {
//              localStorage.setItem("nextAcademicSessionId", nextYear.id);
//            }
//          }
//        }
//      } catch (error) {
//        console.error("Error fetching academic years:", error);
//      }
//    };
//    fetchAcademicYears();
//  }, []);

//   const toggleDrawer = (anchor, open) => (event) => {
//     if (
//       event.type === "keydown" &&
//       (event.key === "Tab" || event.key === "Shift")
//     ) {
//       return;
//     }
//     setState({ ...state, [anchor]: open });
//   };

//   const handleLogout = () => {
//     const logoutConfirmed = window.confirm("Are you sure you want to logout?");
//     if (logoutConfirmed) {
//       sessionStorage.removeItem("userRole");
//       sessionStorage.removeItem("userId");
//       sessionStorage.removeItem("userTypeId");
//       sessionStorage.removeItem("username");
//       localStorage.clear();
//       window.location.href = "/login";
//     }
//   };

//   const handleSessionChange = (event) => {
//     const selectedCode = event.target.value;
//     setAcademicSession(selectedCode);
//     const selectedYear = academicYears.find(
//       (year) => year.code === selectedCode
//     );
//     if (selectedYear) {
//       localStorage.setItem("academicSessionId", selectedYear.id);
//       localStorage.setItem("orgId", selectedYear.orgId || ""); // Store orgId or empty string
//       localStorage.setItem("branchId", selectedYear.branchId || ""); // Store branchId or empty string

//       // Set next academic session in localStorage if it exists
//       const nextYearCode = `${parseInt(selectedYear.code.split("-")[0]) + 1}-${(
//         parseInt(selectedYear.code.split("-")[1]) + 1
//       )
//         .toString()
//         .slice(-2)}`;
//       const nextYear = academicYears.find((year) => year.code === nextYearCode);
//       if (nextYear) {
//         localStorage.setItem("nextAcademicSessionId", nextYear.id);
//       }
//     }
//   };

//   return (
//     <Box sx={{ flexGrow: 1 }}>
//       <AppBar position="static">
//         <Toolbar>
//           {/* Left Menu Icon */}
//           <IconButton
//             size="large"
//             edge="start"
//             color="inherit"
//             aria-label="menu"
//             sx={{ mr: 2 }}
//             onClick={toggleDrawer("left", true)}
//           >
//             <MenuIcon />
//           </IconButton>
//           {/* Centered Academic Session */}
//           <Grid
//             container
//             alignItems="center"
//             justifyContent="center"
//             sx={{ flexGrow: 1 }}
//           >
//             <Grid item>
//               <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
//                 Academic Session: {academicSession}
//               </Typography>
//             </Grid>
//             <Grid item>
//               <FormControl variant="outlined" sx={{ ml: 0, minWidth: 150 }}>
//                 <InputLabel>Select Session</InputLabel>
//                 <Select
//                   value={academicSession}
//                   onChange={handleSessionChange}
//                   label="Select Session"
//                 >
//                   {academicYears.map((year) => (
//                     <MenuItem key={year.id} value={year.code}>
//                       {year.code}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>
//           </Grid>
//           {/* Right Logout Button */}
//           <Button color="inherit" onClick={handleLogout}>
//             Logout
//           </Button>
//         </Toolbar>
//       </AppBar>
//       {/* Sidebar Component */}
//       <Sidebar state={state} setState={setState} toggleDrawer={toggleDrawer} />
//     </Box>
//   );
// }

// export default Navbar;

// import * as React from "react";
// import AppBar from "@mui/material/AppBar";
// import Box from "@mui/material/Box";
// import Toolbar from "@mui/material/Toolbar";
// import Typography from "@mui/material/Typography";
// import Button from "@mui/material/Button";
// import IconButton from "@mui/material/IconButton";
// import MenuIcon from "@mui/icons-material/Menu";
// import Sidebar from "./Sidebar";
// import { ApiUrl } from "../ApiUrl";
// import { Select, MenuItem, FormControl, InputLabel, Grid } from "@mui/material";
// function Navbar({ onLogout }) {
//   const [state, setState] = React.useState({
//     top: false,
//     left: false,
//     bottom: false,
//     right: false,
//   });
//   const [academicSession, setAcademicSession] = React.useState("");
//   const [academicYears, setAcademicYears] = React.useState([]);
//   const [currentDateTime, setCurrentDateTime] = React.useState(""); // State for date and time
//   React.useEffect(() => {
//     const fetchAcademicYears = async () => {
//       try {
//         const response = await fetch(
//           `${ApiUrl.apiurl}AcademicYear/GetAllAcademicYear/`
//         );
//         const data = await response.json();
//         if (data.message === "Success") {
//           setAcademicYears(
//             data.data.map((year) => ({
//               id: year.id,
//               code: year.sesion_code,
//               orgId: year.org_id || null,
//               branchId: year.branch_id || null,
//               dateFrom: new Date(year.date_from),
//               dateTo: new Date(year.date_to),
//             }))
//           );
//           const currentDate = new Date();
//           const currentYearData = data.data.find((year) => {
//             const dateFrom = new Date(year.date_from);
//             const dateTo = new Date(year.date_to);
//             return currentDate >= dateFrom && currentDate <= dateTo;
//           });
//           if (currentYearData) {
//             setAcademicSession(currentYearData.sesion_code);
//             localStorage.setItem("academicSessionId", currentYearData.id);
//             localStorage.setItem("orgId", currentYearData.org_id || "");
//             localStorage.setItem("branchId", currentYearData.branch_id || "");
//             const nextYear = data.data.find(
//               (year) => new Date(year.date_from) > new Date(currentYearData.date_to)
//             );
//             if (nextYear) {
//               localStorage.setItem("nextAcademicSessionId", nextYear.id);
//             }
//           }
//         }
//       } catch (error) {
//         console.error("Error fetching academic years:", error);
//       }
//     };
//     fetchAcademicYears();
//   }, []);
//   React.useEffect(() => {
//     const updateTime = () => {
//       const now = new Date();
//       const formattedDateTime = now.toLocaleString("en-US", {
//         weekday: "long",
//         year: "numeric",
//         month: "long",
//         day: "numeric",
//         hour: "numeric",
//         minute: "numeric",
//         second: "numeric",
//         hour12: true,
//       });
//       setCurrentDateTime(formattedDateTime);
//     };
//     updateTime(); // Set initial time
//     const interval = setInterval(updateTime, 1000); // Update time every second
//     return () => clearInterval(interval); // Cleanup interval on unmount
//   }, []);
//   const toggleDrawer = (anchor, open) => (event) => {
//     if (
//       event.type === "keydown" &&
//       (event.key === "Tab" || event.key === "Shift")
//     ) {
//       return;
//     }
//     setState({ ...state, [anchor]: open });
//   };
//   const handleLogout = () => {
//     const logoutConfirmed = window.confirm("Are you sure you want to logout?");
//     if (logoutConfirmed) {
//       sessionStorage.removeItem("userRole");
//       sessionStorage.removeItem("userId");
//       sessionStorage.removeItem("userTypeId");
//       sessionStorage.removeItem("username");
//       localStorage.clear();
//       window.location.href = "/login";
//     }
//   };
//   const handleSessionChange = (event) => {
//     const selectedCode = event.target.value;
//     setAcademicSession(selectedCode);
//     const selectedYear = academicYears.find(
//       (year) => year.code === selectedCode
//     );
//     if (selectedYear) {
//       localStorage.setItem("academicSessionId", selectedYear.id);
//       localStorage.setItem("orgId", selectedYear.orgId || "");
//       localStorage.setItem("branchId", selectedYear.branchId || "");
//       const nextYearCode = `${parseInt(selectedYear.code.split("-")[0]) + 1}-${(
//         parseInt(selectedYear.code.split("-")[1]) + 1
//       )
//         .toString()
//         .slice(-2)}`;
//       const nextYear = academicYears.find((year) => year.code === nextYearCode);
//       if (nextYear) {
//         localStorage.setItem("nextAcademicSessionId", nextYear.id);
//       }
//     }
//   };
//   return (
//     <Box sx={{ flexGrow: 1 }}>
//       <AppBar position="static">
//         <Toolbar sx={{ padding: 0 }}>
//           <IconButton
//             size="large"
//             edge="start"
//             color="inherit"
//             aria-label="menu"
//             sx={{ mr: 2 }}
//             onClick={toggleDrawer("left", true)}
//           >
//             <MenuIcon />
//           </IconButton>
//           <Grid container alignItems="center" justifyContent="end" sx={{ flexGrow: 1 }}>
//             {/* Center: Academic Session */}
//             <Grid
//               item
//               xs={4}
//               container
//               justifyContent="center"
//               alignItems="center"
//               sx={{ padding: 0, margin: 0 }} // Remove padding and margin
//             >
//               <Typography variant="h6" component="div" sx={{ marginRight: 2 }}>
//                 Academic Session:
//               </Typography>
//               <FormControl variant="outlined" sx={{ minWidth: 140, padding: 0, margin: 0 }}>
//                 <InputLabel>Select Session</InputLabel>
//                 <Select
//                   value={academicSession}
//                   onChange={handleSessionChange}
//                   label="Select Session"
//                 >
//                   {academicYears.map((year) => (
//                     <MenuItem key={year.id} value={year.code}>
//                       {year.code}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>
//             {/* Right: Date and Logout */}
//             <Grid
//               item
//               xs={4}
//               container
//               justifyContent="flex-end"
//               alignItems="center"
//               sx={{ padding: 0, margin: 0 }} // Remove padding and margin
//             >
//               {/* Date and Time */}
//               <Typography variant="body1" sx={{ mr: 2 }}>
//                 {currentDateTime}
//               </Typography>
//               {/* Logout Button */}
//               <Button
//                 color="inherit"
//                 onClick={handleLogout}
//                 sx={{
//                   border: "1px solid white",
//                   padding: 1, // Remove padding
//                   minWidth: "auto", // Make the button content fit naturally
//                   margin: 0, // Remove margin
//                 }}
//               >
//                 Logout
//               </Button>
//             </Grid>
//           </Grid>
//         </Toolbar>
//       </AppBar>
//       <Sidebar state={state} setState={setState} toggleDrawer={toggleDrawer} />
//     </Box>
//   );
// }
// export default Navbar;

//23/07/

// import * as React from "react";
// import AppBar from "@mui/material/AppBar";
// import Box from "@mui/material/Box";
// import Toolbar from "@mui/material/Toolbar";
// import Typography from "@mui/material/Typography";
// import Button from "@mui/material/Button";
// import IconButton from "@mui/material/IconButton";
// import MenuIcon from "@mui/icons-material/Menu";
// import Sidebar from "./Sidebar";
// import { ApiUrl } from "../ApiUrl";
// import { Select, MenuItem, FormControl, InputLabel, Grid } from "@mui/material";
// function Navbar({ onLogout }) {
//   const [state, setState] = React.useState({
//     top: false,
//     left: false,
//     bottom: false,
//     right: false,
//   });
//   const [academicSession, setAcademicSession] = React.useState("");
//   const [academicYears, setAcademicYears] = React.useState([]);
//   const [currentDateTime, setCurrentDateTime] = React.useState(""); // State for date and time

//   React.useEffect(() => {
//     const fetchAcademicYears = async () => {
//       try {
//         const response = await fetch(
//           `${ApiUrl.apiurl}AcademicYear/GetAllAcademicYear/`
//         );
//         const data = await response.json();
//         if (data.message === "Success") {
//           const formattedYears = data.data.map((year) => ({
//             id: year.id,
//             code: year.sesion_code,
//             orgId: year.org_id || null,
//             branchId: year.branch_id || null,
//             dateFrom: new Date(year.date_from),
//             dateTo: new Date(year.date_to),
//           }));
//           setAcademicYears(formattedYears);

//           const storedSessionId = localStorage.getItem("academicSessionId");
//           let currentYearData = null;

//           if (storedSessionId) {
//             // Find session by stored ID
//             currentYearData = formattedYears.find(
//               (year) => year.id.toString() === storedSessionId
//             );
//           } else {
//             // Find current session based on date
//             const currentDate = new Date();
//             currentYearData = formattedYears.find((year) => {
//               return currentDate >= year.dateFrom && currentDate <= year.dateTo;
//             });
//           }

//           if (currentYearData) {
//             setAcademicSession(currentYearData.code);
//             localStorage.setItem("academicSessionId", currentYearData.id);
//             localStorage.setItem("orgId", currentYearData.orgId || "");
//             localStorage.setItem("branchId", currentYearData.branchId || "");
//             localStorage.setItem(
//               "dateFrom",
//               currentYearData.dateFrom.toISOString().split("T")[0]
//             );

//             // Find next session
//             const nextYear = formattedYears.find(
//               (year) => year.dateFrom > currentYearData.dateTo
//             );
//             if (nextYear) {
//               localStorage.setItem("nextAcademicSessionId", nextYear.id);
//             }
//           }
//         }
//       } catch (error) {
//         console.error("Error fetching academic years:", error);
//       }
//     };

//     fetchAcademicYears();
//   }, []);

//   React.useEffect(() => {
//     const updateTime = () => {
//       const now = new Date();
//       const formattedDateTime = now.toLocaleString("en-US", {
//         weekday: "long",
//         year: "numeric",
//         month: "long",
//         day: "numeric",
//         hour: "numeric",
//         minute: "numeric",
//         second: "numeric",
//         hour12: true,
//       });
//       setCurrentDateTime(formattedDateTime);
//     };
//     updateTime(); // Set initial time
//     const interval = setInterval(updateTime, 1000); // Update time every second
//     return () => clearInterval(interval); // Cleanup interval on unmount
//   }, []);
//   const toggleDrawer = (anchor, open) => (event) => {
//     if (
//       event.type === "keydown" &&
//       (event.key === "Tab" || event.key === "Shift")
//     ) {
//       return;
//     }
//     setState({ ...state, [anchor]: open });
//   };
//   const handleLogout = () => {
//     const logoutConfirmed = window.confirm("Are you sure you want to logout?");
//     if (logoutConfirmed) {
//       sessionStorage.removeItem("userRole");
//       sessionStorage.removeItem("userId");
//       sessionStorage.removeItem("userTypeId");
//       sessionStorage.removeItem("username");
//       localStorage.clear();
//       window.location.href = "/login";
//     }
//   };


//   const handleSessionChange = (event) => {
//     const selectedCode = event.target.value;
//     setAcademicSession(selectedCode);
//     const selectedYear = academicYears.find(
//       (year) => year.code === selectedCode
//     );
//     if (selectedYear) {
//       localStorage.setItem("academicSessionId", selectedYear.id);
//       localStorage.setItem("orgId", selectedYear.orgId || "");
//       localStorage.setItem("branchId", selectedYear.branchId || "");

//       const nextYearCode = `${parseInt(selectedYear.code.split("-")[0]) + 1}-${(
//         parseInt(selectedYear.code.split("-")[1]) + 1
//       )
//         .toString()
//         .slice(-2)}`;
//       const nextYear = academicYears.find((year) => year.code === nextYearCode);
//       if (nextYear) {
//         localStorage.setItem("nextAcademicSessionId", nextYear.id);
//       }

//       //  Dispatch custom event
//       window.dispatchEvent(new Event("academicSessionChanged"));
//     }
//   };

//   return (
//     <Box sx={{ flexGrow: 1 }}>
//       <AppBar position="static">
//         <Toolbar sx={{ padding: 0 }}>
//           <IconButton
//             size="large"
//             edge="start"
//             color="inherit"
//             aria-label="menu"
//             sx={{ mr: 2 }}
//             onClick={toggleDrawer("left", true)}
//           >
//             <MenuIcon />
//           </IconButton>
//           <Grid
//             container
//             alignItems="center"
//             justifyContent="end"
//             sx={{ flexGrow: 1 }}
//           >
//             {/* Center: Academic Session */}
//             <Grid
//               item
//               xs={4}
//               container
//               justifyContent="center"
//               alignItems="center"
//               sx={{ padding: 0, margin: 0 }} // Remove padding and margin
//             >
//               <Typography variant="h6" component="div" sx={{ marginRight: 2 }}>
//                 Academic Session:
//               </Typography>
//               <FormControl
//                 variant="outlined"
//                 sx={{ minWidth: 140, padding: 0, margin: 0 }}
//               >
//                 <InputLabel>Select Session</InputLabel>
//                 <Select
//                   value={academicSession}
//                   onChange={handleSessionChange}
//                   label="Select Session"
//                 >
//                   {academicYears.map((year) => (
//                     <MenuItem key={year.id} value={year.code}>
//                       {year.code}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>
//             {/* Right: Date and Logout */}
//             <Grid
//               item
//               xs={4}
//               container
//               justifyContent="flex-end"
//               alignItems="center"
//               sx={{ padding: 0, margin: 0 }} // Remove padding and margin
//             >
//               {/* Date and Time */}
//               <Typography variant="body1" sx={{ mr: 2 }}>
//                 {currentDateTime}
//               </Typography>
//               {/* Logout Button */}
//               <Button
//                 color="inherit"
//                 onClick={handleLogout}
//                 sx={{
//                   border: "1px solid white",
//                   padding: 1, // Remove padding
//                   minWidth: "auto", // Make the button content fit naturally
//                   margin: 0, // Remove margin
//                 }}
//               >
//                 Logout
//               </Button>
//             </Grid>
//           </Grid>
//         </Toolbar>
//       </AppBar>
//       <Sidebar state={state} setState={setState} toggleDrawer={toggleDrawer} />
//     </Box>
//   );
// }
// export default Navbar;
import * as React from "react";
import {
  AppBar,
  Box,
  Toolbar,
  Typography,
  Button,
  IconButton,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Grid,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import Sidebar from "./Sidebar";
import { ApiUrl } from "../ApiUrl";
import { useTheme } from "@mui/material/styles";

const getNextAcademicYear = (years, selectedYear) => {
  const sortedYears = [...years].sort((a, b) => a.dateFrom - b.dateFrom);
  const currentYearIndex = sortedYears.findIndex(
    (year) => year.id === selectedYear.id
  );

  return currentYearIndex >= 0 ? sortedYears[currentYearIndex + 1] : null;
};

const persistAcademicSession = (selectedYear, years, onSessionChange) => {
  if (!selectedYear) {
    return;
  }

  localStorage.setItem("academicSessionId", selectedYear.id);
  localStorage.setItem("orgId", selectedYear.orgId || "");
  localStorage.setItem("branchId", selectedYear.branchId || "");
  localStorage.setItem(
    "dateFrom",
    selectedYear.dateFrom.toISOString().split("T")[0]
  );

  const nextYear = getNextAcademicYear(years, selectedYear);
  if (nextYear) {
    localStorage.setItem("nextAcademicSessionId", nextYear.id);
  } else {
    localStorage.removeItem("nextAcademicSessionId");
  }

  if (onSessionChange) {
    onSessionChange();
  }
};

function Navbar({ onLogout }) {
  const [state, setState] = React.useState({ left: false });
  const [academicSession, setAcademicSession] = React.useState("");
  const [academicYears, setAcademicYears] = React.useState([]);
  const [currentDateTime, setCurrentDateTime] = React.useState("");

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  React.useEffect(() => {
    const fetchAcademicYears = async () => {
      try {
        const teacherId = sessionStorage.getItem("userId");
        const [academicYearResponse, teacherResponse] = await Promise.all([
          fetch(`${ApiUrl.apiurl}AcademicYear/GetAllAcademicYear/`),
          teacherId
            ? fetch(
                `${ApiUrl.apiurl}Teacher/GetEmployeeList/?employeeId=${teacherId}`
              )
            : Promise.resolve(null),
        ]);

        const data = await academicYearResponse.json();
        if (data.message === "Success") {
          const formattedYears = (data.data || [])
            .map((year) => ({
              id: year.id,
              code: year.sesion_code,
              orgId: year.org_id || null,
              branchId: year.branch_id || null,
              dateFrom: new Date(year.date_from),
              dateTo: new Date(year.date_to),
            }))
            .sort((a, b) => a.dateFrom - b.dateFrom);

          let teacherProfile = null;
          if (teacherResponse?.ok) {
            const teacherPayload = await teacherResponse.json();
            if (
              teacherPayload?.message === "success" &&
              Array.isArray(teacherPayload.data) &&
              teacherPayload.data.length > 0
            ) {
              teacherProfile = teacherPayload.data[0];
            }
          }

          const scopedYears = teacherProfile
            ? formattedYears.filter(
                (year) =>
                  String(year.orgId) === String(teacherProfile.org_id) &&
                  String(year.branchId) === String(teacherProfile.branch_id)
              )
            : formattedYears;

          setAcademicYears(scopedYears);

          const storedSessionId = localStorage.getItem("academicSessionId");
          const forceAutoAcademicSession =
            sessionStorage.getItem("forceAutoAcademicSession") === "true";
          let currentYearData = null;


      if (storedSessionId) {
        currentYearData = scopedYears.find(
          (year) => year.id.toString() === storedSessionId,
        );
      }

          if (!currentYearData) {
            const currentDate = new Date();
            currentYearData = scopedYears.find(
              (year) =>
                currentDate >= year.dateFrom && currentDate <= year.dateTo
            );
          }

          if (!currentYearData && scopedYears.length > 0) {
            currentYearData = scopedYears[scopedYears.length - 1];
          }

          if (currentYearData) {
            setAcademicSession(currentYearData.code);
            persistAcademicSession(
              currentYearData,
              scopedYears,
              () => window.dispatchEvent(new Event("academicSessionChanged"))
            );
          }

          if (forceAutoAcademicSession) {
            sessionStorage.removeItem("forceAutoAcademicSession");
          }
        }
      } catch (error) {
        console.error("Error fetching academic years:", error);
      }
    };

    fetchAcademicYears();
  }, []);

  React.useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      const formatted = now.toLocaleString("en-US", {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        hour12: true,
      });
      setCurrentDateTime(formatted);
    };
    updateTime();
    const interval = setInterval(updateTime, 1000);
    return () => clearInterval(interval);
  }, []);

  const handleSessionChange = (e) => {
    const selectedCode = e.target.value;
    setAcademicSession(selectedCode);
    const selectedYear = academicYears.find(
      (year) => year.code === selectedCode
    );

    if (selectedYear) {
      persistAcademicSession(
        selectedYear,
        academicYears,
        () => window.dispatchEvent(new Event("academicSessionChanged"))
      );
    }
  };

  const handleLogout = () => {
    const confirmed = window.confirm("Are you sure you want to logout?");
    if (confirmed) {
      sessionStorage.clear();
      localStorage.clear();
      window.location.href = "/login";
    }
  };


 return (
   <Box sx={{ flexGrow: 1 }}>
     <AppBar position="static">
       <Toolbar>
         <Grid container alignItems="center" justifyContent="space-between">
           {/* Sidebar toggle icon - Left */}
           <Grid item xs="auto">
             <IconButton
               size="large"
               edge="start"
               color="inherit"
               aria-label="menu"
               disableRipple
               disableFocusRipple
               onClick={() => setState({ ...state, left: true })}
               sx={{
                 "&:hover": { backgroundColor: "transparent" }, // removes hover grey
               }}
             >
               <MenuIcon />
             </IconButton>
           </Grid>

           {/* Academic Session - Centered */}
           <Grid item xs={12} sm={6} md={4}>
             <Box
               display="flex"
               alignItems="center"
               justifyContent="center"
               sx={{ width: "100%" }}
             >
               <Typography variant="body1" sx={{ color: "#fff", mr: 1 }}>
                 Academic Session:
               </Typography>
               <FormControl size="small" sx={{ minWidth: 140 }}>
                 <InputLabel sx={{ color: "#fff" }}>Select Session</InputLabel>
                 <Select
                   value={academicSession}
                   onChange={handleSessionChange}
                   label="Select Session"
                   sx={{ color: "#fff" }}
                 >
                   {academicYears.map((year) => (
                     <MenuItem key={year.id} value={year.code}>
                       {year.code}
                     </MenuItem>
                   ))}
                 </Select>
               </FormControl>
             </Box>
           </Grid>

           {/* Time & Logout - Right */}
           <Grid item xs="auto">
             <Box
               sx={{
                 display: "flex",
                 alignItems: "center",
                 gap: 2,
                 flexWrap: "wrap",
               }}
             >
               <Typography variant="body2" sx={{ color: "#fff" }}>
                 {currentDateTime}
               </Typography>
               <Button
                 color="inherit"
                 onClick={handleLogout}
                 sx={{
                   border: "1px solid white",
                   padding: "4px 12px",
                   fontSize: "0.875rem",
                 }}
               >
                 Logout
               </Button>
             </Box>
           </Grid>
         </Grid>
       </Toolbar>
     </AppBar>

     {/* Sidebar Drawer */}
     <Sidebar state={state} setState={setState} toggleDrawer={() => {}} />
   </Box>
 );

}

export default Navbar;

